// extracted by mini-css-extract-plugin
export var modal = "_b2-0";